import { Box, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import React from "react";
import { styles } from "./styles";

interface Props {
  heading: string;
  data: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

const UserDetailFieldCard: React.FC<Props> = ({
  heading,
  data,
  icon,
  onClick,
}) => {
  const displayData =
    data === null || data === undefined || data === "" ? "N/A" : data;

  return (
    <Box
      component={onClick ? "button" : "div"}
      type={onClick ? "button" : undefined}
      onClick={onClick}
      sx={onClick ? styles.tileButton : styles.tile}
    >
      {icon ? <Box sx={styles.tileIcon}>{icon}</Box> : null}
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={styles.tileLabel}>{heading}</Typography>
        <Typography component="span" sx={styles.tileValue}>
          {displayData}
          {onClick ? <ArrowOutwardIcon aria-hidden /> : null}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserDetailFieldCard;
